<template>
  <div>
    <div class="m-b-10">
      <div class="embed-responsive embed-responsive-16by9">
        <youtube
          :video-id="videoId"
          player-width="100%"
          player-height="100%"></youtube>
      </div>
    </div>
  </div>
</template>
<script>
import { getIdFromURL } from 'vue-youtube-embed'

export default {
  name: 'story-youtube-player',
  props: {
    source: {
      type: String
    }
  },
  data () {
    return {
      videoId: false,
    }
  },
  watch: {
    'source' (to, from) {
      if (to && to != from) {
        this.init()
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (this.source) {
          this.videoId =  getIdFromURL(this.source)
      }
    }
  }
}
</script>
